export default (blob, fileName?: string) => {
    const downloadLink = document.createElement('a')
    downloadLink.target = '_blank'
    const URL = window.URL || window.webkitURL
    const objectUrl = URL.createObjectURL(blob)
    downloadLink.href = objectUrl
    if (fileName) downloadLink.download = fileName
    downloadLink.click()
    URL.revokeObjectURL(objectUrl)
}
